const mapAggregateCollectionToDropdownOptions = collection => {
    if (!Array.isArray(collection)) { throw new Error('`collection` must be an Array.') }
    return collection.map(item => {
        return {
            label: item.key,
            value: item.id
        }
    })
}

const sortDropdownOptions = options => {
    if (!Array.isArray(options)) { throw new Error('`options` must be an Array.') }
    return options.sort((left, right) => {
        return left.label.toLowerCase() < right.label.toLowerCase() ? -1 : (left.label.toLowerCase() > right.label.toLowerCase() ? 1 : 0)
    })
}

export {
    mapAggregateCollectionToDropdownOptions,
    sortDropdownOptions
}
